// extracted by mini-css-extract-plugin
export default {"ProjectTile":"ProjectTile_ProjectTile__ENK9q","Title":"ProjectTile_Title__EpBAu","ProjectImageContainer":"ProjectTile_ProjectImageContainer__pHPr2"};